import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useForm, Controller, useWatch } from "react-hook-form";
import PropTypes from "prop-types";
import {
    makeStyles,
    Typography,
    Box,
} from "@material-ui/core";

export default function ConstructionPage() {
  const useStyles = makeStyles((theme) => ({
    contentBox:{
      position:'relative',
      backgroundColor:'rgba(0,0,0,0.7)',
      height:'100%'
    },
    contentImg:{
      // position:'absolute'
      height:"80%",
      width:'80%',
      margin:'0 auto'
    }
  }));
  const classes = useStyles();
    return (
        <Box className={ classes.contentBox } >
          <Box className={ classes.contentImg } >
            <img src={ '/assets/images/construction.webp' }/>
          </Box>
            
        </Box>
    )
}
